module.exports = __webpack_public_path__ + "img/attraction-2.79172c90.jpg";